import { render, staticRenderFns } from "./OrderEidEdit.vue?vue&type=template&id=1225d942"
import script from "./OrderEidEdit.vue?vue&type=script&lang=js"
export * from "./OrderEidEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports